import getMainAndSubKeyWithUtilsDirContent from '@/utils/getMainAndSubKey'

const itemsTranslateFormat = (translatedItems, gameCategory, oddsKey) => {
  switch (gameCategory) {
    case 'QXC7':
    case '5PL5':
    case 'SSC5':
    case 'BG04':
    case 'BINGO':
      return translatedItems.join('')

    // 當印度彩投注為 n+1 時(spOddsKeys), translatedItems 包含特別號且固定排在第一個
    case 'IC65': {
      const spOddsKeys = [
        'SP:MATCH:1:BALL:6',
        'SP:MATCH:1:BALL:5',
        'SP:MATCH:1:BALL:4',
        'SP:MATCH:1:BALL:3',
        'SP:MATCH:1:BALL:2',
        'SP:MATCH:1:BALL:1',
        'MATCH:SP:0:CHOOSE:5:0',
        'MATCH:SP:0:CHOOSE:6:0'
      ]
      if (spOddsKeys.includes(oddsKey)) {
        const sp = translatedItems.shift()
        return `${translatedItems.join(',')} + ${sp}`
      }
      return translatedItems.join(',')
    }
    default:
      return translatedItems.join(',')
  }
}

export default {
  methods: {
    $_lottoTranslateToCategory (lotto) {
      let gameCategory = ''

      switch (lotto) {
        case 'PC28':
        case 'CA28':
        case 'BL28':
          gameCategory = 'BL28'
          break
        case 'LHC6':
        case 'LHL6':
          gameCategory = 'LHC6'
          break
        case 'SSL3':
        case 'FC3D':
          gameCategory = 'SSL3'
          break
        default:
          gameCategory = lotto
          break
      }

      return gameCategory
    },
    $_betRecordText (betInfo, gameCategory) {
      const { odds } = betInfo
      const items = betInfo.items || []
      const { value } = odds
      const { mainKey, supKey, groupKey } = this.$_getMainAndSubKey(betInfo, gameCategory)
      // 以下註解 - 因為後端API 會直接提供 lotto
      // const lotto = gameId.split('-')[1]
      const translatedItems = items.map(item => this.$t(item))
      const itemsText = items.length === 0 ? '' : itemsTranslateFormat(translatedItems, gameCategory, odds.key)
      const mainText = this.$t(mainKey)
      const ns = [`games/${gameCategory}`, 'general', 'phase']
      const subText = supKey === '' ? '' : this.$t(supKey, { ns })
      const getGroupTranslateToGroupText = this.$_translateGroupKeyToGroupText(groupKey, gameCategory, ns)
      let groupText = ''
      switch (getGroupTranslateToGroupText) {
        case '':
          groupText = ''
          break
        default:
          groupText = subText === '' || !isNaN(getGroupTranslateToGroupText) ? getGroupTranslateToGroupText : ` - ${getGroupTranslateToGroupText}`
          break
      }
      return {
        mainText,
        subText,
        groupText: groupText,
        itemsText,
        value
      }
    },
    $_translateGroupKeyToGroupText (groupKey, gameCategory, ns) {
      if (!groupKey) return ''
      /*
        todo: 阿飛報表新增lotto後在解開
        const { lotto } = this.$_getGameTypes(gameId)
      */

      // const gameCategory = this.$_lottoTranslateToCategory(gameLotto)
      const translateUrl = require(`@/utils/translBetKeyToI18N/${gameCategory}.js`).default(groupKey)
      const translateBetKey = Array.isArray(translateUrl) ? translateUrl.map(item => this.$t(item)).join('') : this.$t(translateUrl)
      const translatedBet = isNaN(Number(translateBetKey))
        ? this.$t(translateBetKey, { ns })
        : translateBetKey
      return translatedBet
    },
    // 抓主要玩法跟次要玩法的key
    $_getMainAndSubKey (betInfo, gameCategory) {
      const { key } = betInfo.odds
      /*
        todo: 阿飛報表新增lotto後在解開
        if (!this.$_getGameTypes(game_id)) return
        const { lotto } = this.$_getGameTypes(game_id)
      */
      // 以下註解 - 因為後端API 會直接提供 lotto
      // const lotto = gameId.split('-')[1]

      return getMainAndSubKeyWithUtilsDirContent(key, gameCategory)
    }
  }
}
